/* global PubSub:true*/
import React from 'react'
import PropTypes from 'prop-types'
import { bowserFlags } from 'lib/bowser'
import { track } from 'lib/analytics'
import { AppPromoAddItemModal } from 'shared/app-modal-wave'
import { getExperimentGroupName } from 'lib/isInExperiment'
import {
  HIDDEN_APP_MODAL_EVENT,
  HIDE_APP_MODAL_EVENT,
  SHOW_APP_MODAL_EVENT,
} from './constants'
import { mobileAppDownloadPath } from '../lib/urls'

export default class AppModal extends React.Component {
  static propTypes = {
    isPinterest: PropTypes.bool,
  }

  state = {
    isVisible: false,
  }

  componentDidMount() {
    PubSub.subscribe(SHOW_APP_MODAL_EVENT, (data) => {
      if (bowserFlags.ios || bowserFlags.android) {
        this.setState({
          isVisible: true,
        })
        this.trackAppDownloadInterstitialViewed()
      }
    })

    PubSub.subscribe(HIDE_APP_MODAL_EVENT, (event) => {
      this.hideModal()
    })
  }

  hideModal = () => {
    this.setState({ isVisible: false }, () => {
      PubSub.publish(HIDDEN_APP_MODAL_EVENT)
    })
  }

  appDownloadTrackingAttributes = () => {
    const experiments =
      typeof window === 'undefined' ? [] : window.currentUser?.experiments
    const experimentGroup = getExperimentGroupName(
      experiments,
      'mobile_web_interstitial_experiment'
    )

    return {
      eventLocation: track.EventLocation.TOOLBAR_MINUS_APP_DOWNLOAD,
      experimentName: experimentGroup
        ? 'mobile_web_interstitial_experiment'
        : null,
      experimentGroup,
    }
  }

  trackAppDownloadInterstitialViewed = () => {
    track.appDownloadInterstitialViewed(this.appDownloadTrackingAttributes())
  }

  render() {
    return (
      <AppPromoAddItemModal
        trackAttributes={this.appDownloadTrackingAttributes()}
        isVisible={this.state.isVisible}
        hideModal={this.hideModal}
        downloadPath={mobileAppDownloadPath()}
      />
    )
  }
}
